import { render, staticRenderFns } from "./BTagSelect.vue?vue&type=template&id=6f802b8a"
import script from "./BTagSelect.vue?vue&type=script&lang=js"
export * from "./BTagSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports